import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=checking, null=guest, object=logged in

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/api/auth/me');
        setUser(data);
      } catch {
        setUser(null);
      }
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/api/auth/login', { email, password });
    setUser(data);
    return data;
  }, []);

  const acceptInvite = useCallback(async (token, name, password) => {
    const { data } = await api.post('/api/auth/accept-invite', { token, name, password });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post('/api/auth/logout'); } catch {}
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, acceptInvite }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
